import Vue from 'vue'
import Router from 'vue-router'

// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// detail: https://panjiachen.github.io/vue-element-admin-site/#/lazy-loading

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'
/**
* hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
* alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
*                                if not set alwaysShow, only more than one route under the children
*                                it will becomes nested mode, otherwise not show the root menu
* redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
**/

function notRequireAuth(to, from, next) {
  next()
}

export const constantRouterMap = [
  {
    path: '/',
    name: 'Landing Page',
    component: () => import('@/views/home/index'),
    hidden: true
  },
  // {
  //   path: '/demo',
  //   name: 'Demo',
  //   component: () => import('@/views/home/demo'),
  //   hidden: true
  // },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index'),
    beforeEnter: notRequireAuth,
    hidden: true
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('@/views/forgot-password/index'),
    beforeEnter: notRequireAuth,
    hidden: true
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: () => import('@/views/reset-password/index'),
    beforeEnter: notRequireAuth,
    hidden: true
  },
  {
    path: '/email-pending',
    name: 'email-pending',
    component: () => import('@/views/email-pending/index'),
    beforeEnter: notRequireAuth,
    hidden: true
  },
  {
    path: '/email-confirmation',
    name: 'email-confirmation',
    component: () => import('@/views/email-confirmation/index'),
    beforeEnter: notRequireAuth,
    hidden: true
  },
  {
    path: '/privacy-policy',
    name: 'privacy-policy',
    component: () => import('@/views/privacy-policy/index.vue'),
    hidden: true
  },
  {
    path: '/404',
    redirect: { name: 'Landing Page' },
    // component: () => import('@/views/404'),
    hidden: true
  }
]

export default new Router({
  mode: 'history',
  routes: constantRouterMap,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash }
    } else if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

// merchant
export const asyncRouterMap = [
  {
    path: '',
    component: Layout,
    redirect: '/',
    // hidden: true,
    children: [{
      path: 'index',
      name: 'Home',
      component: () => import('@/views/certificates/index'),
      meta: {
        title: 'Certificates',
        icon: 'dashboard',
        class: 'material-icons',
        size: '16px',
        special: true
      }
    }]
  },
  {
    path: '/change-password',
    component: Layout,
    hidden: true,
    meta: { },
    children: [{
      path: '',
      name: 'Change Password',
      component: () => import('@/views/changePassword/index'),
      meta: { title: 'Change Password', icon: 'form' }
    }]
  },
  { path: '*', redirect: '/404', hidden: true }
]

// root
export const adminRouterMap = [
  {
    path: '',
    component: Layout,
    redirect: '/',
    // hidden: true,
    children: [{
      path: 'index',
      name: 'Mini Url',
      component: () => import('@/views/payload/index'),
      meta: {
        title: 'Mini Url',
        icon: 'cloud-lightning',
        special: true
      }
    }]
  },
  { path: '*', redirect: '/404', hidden: true }
]

export const userRouterMap = [
  {
    path: '',
    component: Layout,
    redirect: '/',
    // hidden: true,
    children: [{
      path: 'index',
      name: 'Home',
      component: () => import('@/views/scan-certificate/index'),
      meta: {
        title: 'Scan Certificate',
        icon: '',
        class: 'dne-scan',
        size: '13px',
        special: true
      }
    }]
  },
  {
    path: '/verification',
    component: Layout,
    hidden: true,
    meta: { },
    children: [
      {
        path: '',
        name: 'verification',
        component: () => import('@/views/verification/index'),
        meta: { title: 'Verification', icon: 'fileText' }
      },
      {
        path: '*',
        redirect: { name: 'Home' }
      }
    ]
  },
  {
    path: '/certificates',
    component: Layout,
    // hidden: true,
    meta: { },
    children: [{
      path: '',
      name: 'certificates',
      component: () => import('@/views/certificates-student/index'),
      meta: {
        title: 'Certificates',
        icon: 'dashboard',
        class: 'material-icons',
        size: '16px',
        special: true
      }
    }]
  },
  {
    path: '/resume',
    component: Layout,
    // hidden: true,
    meta: { },
    children: [{
      path: '',
      name: 'Resume',
      component: () => import('@/views/resume/index'),
      meta: {
        title: 'Resume',
        icon: 'fileText',
        size: '16px',
        special: true
      }
    }]
  },
  {
    path: '/certificate',
    component: Layout,
    hidden: true,
    meta: { },
    children: [
      {
        path: ':id',
        name: 'certificate',
        component: () => import('@/views/certificate/index'),
        meta: { title: 'Certificate', icon: 'fileText' }
      },
      {
        path: '',
        redirect: { name: 'Home' }
      }
    ]
  },
  {
    path: '/resume-builder',
    redirect: '/resume'
  },
  {
    path: '/resume-builder/:resume_id',
    name: 'Resume Builder',
    component: () => import('@/views/resumeBuilder/index'),
    hidden: true,
    meta: { title: 'Resume Builder', icon: 'fileText' }
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]



// WEBPACK FOOTER //
// ./src/router/index.js